import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

export const groupListingSlice = createSlice({
  name: 'groupListing',
  initialState,
  reducers: {
    updateGroupListingSlice: (state, action) => {
      return {
        ...action.payload,
      };
    },
    clearGroupListingSlice: () => {
      return initialState;
    }
  },
})

export const { updateGroupListingSlice, clearGroupListingSlice } = groupListingSlice.actions

export default groupListingSlice.reducer
